import { useState, useCallback } from 'react';

export const useAuthState = () => {
  const [isCheckingAuth, setIsCheckingAuth] = useState(false);

  const waitForAuthentication = useCallback(async (maxAttempts = 10, interval = 500) => {
    setIsCheckingAuth(true);
    try {
      // Check if the SDK is loaded
      if (!window.nbc?.identity) {
        throw new Error("SDK not loaded");
      }

      // Wait for authentication to complete
      let attempts = 0;
      
      while (attempts < maxAttempts) {
        if (window.nbc.identity.authenticationState === "authenticated" && window.nbc.identity.user) {
          console.log('✅ Authentication successful!');
          return true;
        }
        
        await new Promise(resolve => setTimeout(resolve, interval));
        attempts++;
      }

      // Final check for authentication
      if (window.nbc.identity.authenticationState === "authenticated" && window.nbc.identity.user) {
        return true;
      }

      throw new Error("Authentication timed out");
    } catch (error) {
      console.error("Error waiting for authentication:", error);
      throw error;
    } finally {
      setIsCheckingAuth(false);
    }
  }, []);

  return {
    isCheckingAuth,
    waitForAuthentication
  };
};
